import Sidebar from "../Sidebar/Sidebar";
import { Switch, Route } from "react-router-dom";
import "./PracticeLayout.css";
import PracticeDashboard from "../tests/Dashboard/PracticeDashboard";
import AitsPage from "../aits/pages/AitsPage";
import PyqTopicWise from "../aits/components/Header/PaperListing/PyqTopicWise";
import PyqTopicWiseSet from "../aits/components/Header/PaperListing/PyqTopicWiseSet";

const PracticeLayout = () => {
  return (
    <div className="practice-layout">
      <Sidebar />
      <div className="practice-content">
        <Switch>
          <Route exact path="/practice" component={PracticeDashboard} />
          <Route path="/practice/topic-wise/pyqset" component={PyqTopicWiseSet} />
          <Route path="/practice/topic-wise" component={PyqTopicWise} />
          <Route path="/practice/paper-listing" component={AitsPage} />
        </Switch>
      </div>
    </div>
  );
};

export default PracticeLayout;
